// extracted by mini-css-extract-plugin
module.exports = {"phone":"Phone-module--phone--2A7AL"};